import { createSlice } from "@reduxjs/toolkit";
import * as app_consts from "../../utils/app_consts";

const initialState = {
 tenant_update_theoretical_stock_to_physical_stock_balance: { message: "idle" },
};

export const tenant_update_theoretical_stock_to_physical_stock_balance_Slice = createSlice({
 name: "tenant_update_theoretical_stock_to_physical_stock_balance",
 initialState,
 reducers: {
  success_tenant_update_theoretical_stock_to_physical_stock_balance: (state, action) => {
   state.tenant_update_theoretical_stock_to_physical_stock_balance = { status: app_consts.SUCCESS, data: action.payload };
  },
  fail_tenant_update_theoretical_stock_to_physical_stock_balance: (state, action) => {
   state.tenant_update_theoretical_stock_to_physical_stock_balance = { status: app_consts.FAIL, message: action.payload };
  },
  reset_tenant_update_theoretical_stock_to_physical_stock_balance: (state) => {
   state.tenant_update_theoretical_stock_to_physical_stock_balance = { status: app_consts.IDLE };
  },
  loading_tenant_update_theoretical_stock_to_physical_stock_balance: (state) => {
   state.tenant_update_theoretical_stock_to_physical_stock_balance = { status: app_consts.LOADING };
  },
 }
});

export const { success_tenant_update_theoretical_stock_to_physical_stock_balance, fail_tenant_update_theoretical_stock_to_physical_stock_balance, reset_tenant_update_theoretical_stock_to_physical_stock_balance, loading_tenant_update_theoretical_stock_to_physical_stock_balance } = tenant_update_theoretical_stock_to_physical_stock_balance_Slice.actions;

export default tenant_update_theoretical_stock_to_physical_stock_balance_Slice.reducer;